// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as OrderMapMenu from "../types/OrderMapMenu.bs.js";
import * as Icon$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as MenuList$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/menu-list/MenuList.bs.js";

function OrderMapMenuComponent(Props) {
  var hamburgerMenuHandler = Props.hamburgerMenuHandler;
  var menuActions = List.map((function (menu) {
          var menuString = OrderMapMenu.toString(menu);
          return {
                  item_label: {
                    TAG: /* Text */0,
                    _0: menuString
                  },
                  item_cb: (function (param) {
                      return Curry._1(hamburgerMenuHandler, menu);
                    })
                };
        }), {
        hd: /* HideDryRun */0,
        tl: {
          hd: /* ShowDryRun */1,
          tl: /* [] */0
        }
      });
  return React.createElement("div", {
              className: "map-options-dropdown"
            }, React.createElement(MenuList$Catalyst.make, {
                  menuItems: menuActions,
                  custom_menu_button: React.createElement(Icon$Catalyst.MoreVertIcon.make, {
                        className: "dropdown-icon",
                        fontSize: "Large"
                      })
                }));
}

var make = OrderMapMenuComponent;

export {
  make ,
  
}
/* react Not a pure module */
